import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Typography from '@material-ui/core/Typography';
import translations from './translations';

const ShipmentStatus = ({ shipment }) => {
  const intl = useIntl();

  let shipmentStatus = intl.formatMessage(translations.open);

  if (shipment?.is_canceled) {
    shipmentStatus = intl.formatMessage(translations.cancelled);
  }

  if (shipment?.is_listed) {
    shipmentStatus = intl.formatMessage(translations.listed);
  }

  if (shipment?.is_outbound) {
    if (shipment?.is_handled) {
      shipmentStatus = intl.formatMessage(translations.picked);
    }

    if (shipment?.is_boxed) {
      shipmentStatus = intl.formatMessage(translations.boxed);
    }

    if (shipment?.is_in_transit) {
      shipmentStatus = intl.formatMessage(translations.inTransit);
    }
  }

  if (!shipment?.is_outbound) {
    if (shipment?.is_boxed) {
      shipmentStatus = intl.formatMessage(translations.counted);
    }

    if (shipment?.is_handled) {
      shipmentStatus = intl.formatMessage(translations.placed);
    }
  }

  if (shipment?.is_finished) {
    shipmentStatus = intl.formatMessage(translations.finished);
  }

  return (
    <Typography variant="body2" color="textPrimary">
      {shipmentStatus}
    </Typography>
  );
};

ShipmentStatus.propTypes = {
  shipment: PropTypes.object,
};

ShipmentStatus.defaultProps = {
  shipment: undefined,
};

export default ShipmentStatus;
